import { useId } from 'react'
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts'
import { ChartFrame, ChartTooltip, chartTickInterval, toneColor, useThemeTokens } from './chart.jsx'

/**
 * Kunlik trend — maydonli (area) grafik.
 *
 * IKKI SERIYA — IKKI RANG. Ilgari ikkalasi ham oq edi (biri uzuq chiziq),
 * kesishgan joyda ular bir-biriga qo'shilib ketardi va grafikdan qaysi biri
 * qaysiligini ajratib bo'lmasdi. Rang bu yerda bezak emas, ma'no:
 * KELGAN — tizimning oddiy siyohi (`--ui-text-1`): bu ish hajmi, o'zi na
 * yaxshi, na yomon. YOPILGAN — `--ui-st-ok`: bu bajarilgan ish.
 * Ya'ni rang DESIGN.md 4-bo'limdagi mavjud status palitrasidan olinadi,
 * grafik uchun alohida palitra o'ylab topilmaydi.
 *
 * Rang yolg'iz qolmaydi: ikkala chiziq YORUG'LIK bo'yicha ham ajraladi
 * (siyoh — mavzudagi eng kuchli rang, yashil undan pastroq), ustiga
 * afsona va ko'rsatkich (tooltip) seriyani nomi bilan ataydi.
 *
 * UMUMLASHTIRISH (orqaga to'liq mos): `series` berilmasa komponent aynan
 * ilgarigidek ishlaydi — `yangi`/`yopildi` kalitlari va o'sha nomlar.
 * Berilsa, istalgan kalitlar bilan chizadi: AI xarajati, kesh ulushi,
 * xatolar to'lqini. Shuning uchun Dashboard'dagi mavjud chaqiruvga
 * tegilmaydi, yangi sahifalar esa o'z seriyasini beradi.
 *
 * @param data      [{date, …}] — kunlik qatorlar
 * @param height    grafik balandligi (standart 200)
 * @param series    [{key, name, tone}] — tone: 'ink'|'ok'|'critical'|'medium'|'muted'
 * @param valueFmt  ko'rsatkichdagi qiymat formati: v => `$${v}`
 * @param title     ixtiyoriy sarlavha (ramka `ChartFrame` dan keladi)
 * @param actions   sarlavha o'ngidagi boshqaruv (davr tanlagichi va h.k.)
 */
const DEFAULT_SERIES = [
  { key: 'yangi', name: 'Kelgan', tone: 'ink' },
  { key: 'yopildi', name: 'Yopilgan', tone: 'ok' },
]

export default function TrendChart({
  data = [],
  height = 200,
  series = DEFAULT_SERIES,
  valueFmt,
  title,
  sub,
  actions,
}) {
  const t = useThemeTokens()
  const uid = useId().replace(/:/g, '')

  const lines = series.map((s) => ({ ...s, color: toneColor(t, s.tone) }))

  return (
    <ChartFrame
      title={title}
      sub={sub}
      actions={actions}
      height={height}
      legend={lines.map((s) => ({ name: s.name, color: s.color }))}
      empty={!data.length}
    >
      <AreaChart data={data} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
        <defs>
          {/* Chiziq ostidagi to'ldirish — hajmni ko'rsatadi, lekin grafikni
              bo'yamaydi: yuqorida .18, pastda 0 ga tushadi. */}
          {lines.map((s) => (
            <linearGradient key={s.key} id={`${uid}-${s.key}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={s.color} stopOpacity={0.18} />
              <stop offset="100%" stopColor={s.color} stopOpacity={0} />
            </linearGradient>
          ))}
        </defs>

        <CartesianGrid strokeDasharray="3 3" stroke={t['--ui-border']} vertical={false} />
        <XAxis
          dataKey="date"
          interval={chartTickInterval(data.length)}
          minTickGap={16}
          tickMargin={8}
          tick={{ fontSize: 11, fill: t['--ui-text-2'] }}
          tickLine={false}
          stroke={t['--ui-border']}
        />
        <YAxis
          width={40}
          allowDecimals={false}
          tick={{ fontSize: 11, fill: t['--ui-text-2'] }}
          tickLine={false}
          axisLine={false}
        />
        <Tooltip
          content={<ChartTooltip valueFmt={valueFmt} />}
          cursor={{ stroke: t['--ui-border-2'] || t['--ui-border'] }}
        />

        {lines.map((s) => (
          <Area
            key={s.key}
            type="monotone"
            dataKey={s.key}
            name={s.name}
            stroke={s.color}
            strokeWidth={2}
            fill={`url(#${uid}-${s.key})`}
            dot={false}
            activeDot={{ r: 3, strokeWidth: 0 }}
          />
        ))}
      </AreaChart>
    </ChartFrame>
  )
}
